import { LocaleD } from "db"
import * as t from "io-ts"
import * as td from "io-ts-types"

const CategoryTranslationDC = <T extends LocaleD>(locale: T) =>
  t.type({
    locale: t.literal(locale),
    name: t.string,
    namePath: td.nonEmptyArray(t.string),
    slugPath: td.nonEmptyArray(t.string),
  })

export type CategoryTranslationD = t.TypeOf<ReturnType<typeof CategoryTranslationDC>>

export const CategoryDC = t.type({
  translations: t.tuple([CategoryTranslationDC("en_ca"), CategoryTranslationDC("fr_ca")]),
  updatedAt: td.date,
})

export type CategoryD = t.TypeOf<typeof CategoryDC>

export const CategoryWithSubcategoryDC = t.intersection([
  t.type({
    id: t.number,
  }),
  CategoryDC,
  t.partial({ subcategories: t.array(CategoryDC) }),
])

export type CategoryWithSubcategoryD = t.TypeOf<typeof CategoryWithSubcategoryDC>
